import { render, staticRenderFns } from "./banner-dc-vizlet.vue?vue&type=template&id=3d9049c6&scoped=true"
import script from "./banner-dc-vizlet.vue?vue&type=script&lang=js"
export * from "./banner-dc-vizlet.vue?vue&type=script&lang=js"
import style0 from "./banner-dc-vizlet.vue?vue&type=style&index=0&id=3d9049c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9049c6",
  null
  
)

export default component.exports